import { cn } from "~/lib/cn";

export function Wordmark({
  className,
  onDark = false,
}: {
  className?: string;
  onDark?: boolean;
}) {
  const ink = onDark ? "var(--on-navy)" : "var(--color-glacial-navy)";
  const mark = onDark ? "var(--on-navy)" : "var(--kugie-north-star-600)";
  return (
    <span
      className={cn("inline-flex items-center gap-2.5", className)}
      aria-label="Jotty"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 1200 1200"
        fill="none"
        aria-hidden="true"
        style={{ color: mark }}
      >
        <path
          d="M753.863 830.929L446.367 523.466L369.468 600.365L753.829 984.727L984.459 754.063L907.594 677.197L753.863 830.929Z"
          fill="currentColor"
        />
        <path
          d="M138.866 523.51L61.999 600.376L138.866 677.242L215.731 600.376L138.866 523.51Z"
          fill="currentColor"
        />
        <path
          d="M984.401 446.598L753.836 216L676.936 292.866L907.534 523.464L984.401 446.598Z"
          fill="currentColor"
        />
        <path
          d="M446.298 369.798L753.827 677.26L830.694 600.361L446.332 216L215.735 446.664L292.601 523.496L446.298 369.798Z"
          fill="currentColor"
        />
      </svg>
      <span
        className="font-display text-[18px] font-semibold tracking-[-0.01em]"
        style={{ color: ink }}
      >
        Jotty
      </span>
    </span>
  );
}
